// Default time range applied when redirecting to the new alerts inventory page
export const NEW_ALERTS_INVENTORY_TIME_RANGE_PARAMS = 'endTime=now&startTime=-365d';
